import React, { createContext, useContext, useState, useCallback } from "react";

const CTAContext = createContext(null);

export const CTAProvider = ({ children }) => {
  const [ctaHeight, setCTAHeight] = useState(0);

  const setCTAHeightSafe = useCallback((h) => setCTAHeight(h), []);

  return (
    <CTAContext.Provider
      value={{
        ctaHeight,
        setCTAHeight: setCTAHeightSafe,
      }}
    >
      {children}
    </CTAContext.Provider>
  );
};

export const useCTA = () => {
  const ctx = useContext(CTAContext);
  if (!ctx) throw new Error("useCTA must be used within CTAProvider");
  return ctx;
};

export default CTAContext;
